// extracted by mini-css-extract-plugin
module.exports = {"title":"TopBarTitles_title__3oZt0","subtitle":"TopBarTitles_subtitle__3NcgV"};